// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardGridLayoutUIStore.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var GridLayoutUIStore = require('share/components/controls/GridLayout/Izenda.GridLayoutUIStore');
  var GridItemState = require('share/components/controls/GridLayout/Izenda.GridItemState');
  var Constants = require('logic/data/Izenda.DashboardGridConstants');
  var UiState = require('logic/Izenda.UiState');
  const { create, round } = require('lodash/fp');
  var action = require('mobx').action;
  var extendObservable = require('mobx').extendObservable;

  function DashboardGridLayoutUIStore(width, transparent, fullSizeMode) {
    GridLayoutUIStore.call(
      this,
      Constants.GRID_CELL_SIZE, // default grid cell width
      Constants.GRID_CELL_SIZE, // default grid cell height
      width, // dashboard grid width
      Constants.NUMBER_ROWS, // dashboard grid layout rows
      Constants.NUMBER_COLS,
      true, // allow infinity rows
      false, // allow infinity cols
      true, // view in full size mode
      true,
      null,
      null,
      Constants.TILE_MAX_HEIGHT
    );
    extendObservable(this, {
      transparent: !!transparent
    });
  }

  DashboardGridLayoutUIStore.prototype = create(GridLayoutUIStore.prototype, {
    constructor: DashboardGridLayoutUIStore
  });

  DashboardGridLayoutUIStore.prototype.setViewWidth = action(function setViewWidth(width) {
    var newCellSize = round(width / this.cols);

    this.cellWidth = newCellSize;
    this.cellHeight = newCellSize;

    GridLayoutUIStore.prototype.setViewWidth.call(this, width);

    this.recalculateLayoutPosition();
  });

  DashboardGridLayoutUIStore.prototype.setTransparent = action(function(transparent) {
    this.transparent = !!transparent;
  });

  module.exports = DashboardGridLayoutUIStore;
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/Izenda.DashboardGridLayoutUIStore.js